<template>
    <nav class="admin-config-rail" :aria-label="trans('configuration.configuration')">
        <div class="admin-config-rail__head">
            <span class="admin-config-rail__head-title">{{ trans('configuration.configuration') }}</span>
        </div>
        <div class="admin-config-rail__scroll">
            <span class="admin-config-rail__group">{{ trans('general.basic') }}</span>
            <router-link
                to="/configuration/basic"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'basic' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="building"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('general.basic') }}</span>
            </router-link>
            <router-link
                to="/configuration/logo"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'logo' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="image"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('general.logo') }}</span>
            </router-link>
            <router-link
                to="/configuration/system"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'system' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="settings"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('general.system') }}</span>
            </router-link>
            <router-link
                to="/configuration/frontend"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'frontend' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="monitor"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('configuration.frontend_configuration') }}</span>
            </router-link>
            <span class="admin-config-rail__group">Infrastructure</span>
            <router-link
                to="/configuration/server"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'server' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="database"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('configuration.server_configuration') }}</span>
            </router-link>
            <router-link
                to="/configuration/mail"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'mail' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="mail"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('mail.mail') }}</span>
            </router-link>
            <router-link
                to="/configuration/payment"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'payment' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="card"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('configuration.payment_configuration') }}</span>
            </router-link>
            <router-link
                v-if="getConfig('multilingual')"
                to="/configuration/locale"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'locale' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="globe"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('locale.locale') }}</span>
            </router-link>
            <span class="admin-config-rail__group">Access control</span>
            <router-link
                to="/configuration/role"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'role' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="badge"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('role.role') }}</span>
            </router-link>
            <router-link
                to="/configuration/permission"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'permission' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="key"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('permission.permission') }}</span>
            </router-link>
            <router-link
                to="/configuration/authentication"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'authentication' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="shield"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('auth.authentication') }}</span>
            </router-link>
            <span class="admin-config-rail__group">Operations</span>
            <router-link
                v-if="getConfig('ip_filter')"
                to="/configuration/ip-filter"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'ip-filter' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="ethernet"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('ip_filter.ip_filter') }}</span>
            </router-link>
            <router-link
                to="/configuration/instance"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'instance' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="box"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('instance.instance') }}</span>
            </router-link>
            <router-link
                to="/configuration/scheduled-job"
                class="admin-config-rail__link"
                :class="{ 'admin-config-rail__link--active': menu === 'scheduled-job' }"
            >
                <span class="admin-config-rail__icon" aria-hidden="true"><admin-icon name="clock"></admin-icon></span>
                <span class="admin-config-rail__label">{{ trans('general.scheduled_job') }}</span>
            </router-link>
        </div>
    </nav>
</template>

<script>
    export default {
        props: {
            menu: {
                default: ''
            }
        },
        methods: {
            getConfig(config) {
                return helper.getConfig(config);
            }
        }
    };
</script>

<style scoped>
.admin-config-rail {
    background: rgba(248, 249, 252, 0.86);
    border-right: 1px solid #e5e8ef;
    box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.68);
}

.admin-config-rail__head-title {
    color: #8b93a7;
    text-shadow: none;
}

.admin-config-rail__group {
    display: block;
    margin: 0.95rem 0.55rem 0.35rem;
    color: #9aa2b3;
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.11em;
    line-height: 1.2;
    text-transform: uppercase;
}

.admin-config-rail__group:first-child {
    margin-top: 0.15rem;
}

.admin-config-rail__link,
.admin-config-rail__label {
    color: #5c6475;
}

.admin-config-rail__link:hover,
.admin-config-rail__link:hover .admin-config-rail__label {
    background: rgba(255, 255, 255, 0.72);
    color: #343a48;
}

.admin-config-rail__link--active,
.admin-config-rail__link--active .admin-config-rail__label {
    background: rgba(255, 255, 255, 0.94);
    color: #111318;
}

.admin-config-rail__link--active::before {
    display: block;
    content: "";
}

.admin-config-rail__icon {
    background: transparent;
    border-color: transparent;
    color: currentColor;
    opacity: 0.58;
}

.admin-config-rail__link:hover .admin-config-rail__icon {
    color: inherit;
    border-color: transparent;
    opacity: 0.75;
}

.admin-config-rail__link--active .admin-config-rail__icon {
    background: transparent;
    border-color: transparent;
    color: #625cf6;
    opacity: 1;
}
</style>
